import { Children, memo, ReactNode } from "react";
import classNames from "classnames";

import styles from "../style.module.scss";

type DropContainerBodyProps = {
  className?: string,
  children?: ReactNode
}

export const DropContainerBody = memo<DropContainerBodyProps>((
  {
    className,
    children,
  }) => {

  if (!Children.count(children)) {
    return null;
  }

  return (
    <div className={classNames(styles.dropdown, className)}>
      <ul className={styles.dropWrap}>
        {children}
      </ul>
    </div>
  );
});
